import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import './Loader.css'
import { Fade } from '@material-ui/core'
import GridViewSkeleton from '../../molecules/Loaders/ProductCardSkeletons/GridViewSkeleton'
import ListViewSkeleton from '../../molecules/Loaders/ProductCardSkeletons/ListViewSkeleton'
import CartSkeleton from '../../molecules/Loaders/CartSkeleton'
import CheckoutSkeleton from '../../molecules/Loaders/CheckoutSkeleton'
import ProductViewSkeleton from '../../molecules/Loaders/ProductViewSkeleton'
import AuctionSkeleton from './AuctionSkeleton'
import ArchiveSkeleton from './ArchiveSkeleton'
import TableSkeleton from './TableSkeleton'

const returnSwitch = (props) => {
    switch (props.name) {
        case 'product_grid_view':
            return <GridViewSkeleton theme={props.theme} />
        case 'product_list_view':
            return <ListViewSkeleton theme={props.theme} />
        case 'auction':
            return <AuctionSkeleton theme={props.theme} />
        case 'archive':
            return <ArchiveSkeleton theme={props.theme} />
        case 'checkout':
            return <CheckoutSkeleton theme={props.theme} />
        case 'product_view':
            return <ProductViewSkeleton theme={props.theme} />
        case 'table':
            return <TableSkeleton />
        default:
            return <CircularProgress disableShrink />
    }
}

const Loaders = (props) => {
    return (
        <>
            {props.isLoading ? (
                <>
                    <Fade in={props.isLoading} timeout={600}>
                        <div className="loadingCnt">
                            {[...Array(props.loop ? props.loop : 1)].map((data, index) => (
                                <div className={props.name === 'home' ? 'loader' : ''} key={index}>
                                    {returnSwitch(props)}
                                </div>
                            ))}
                        </div>
                    </Fade>
                </>
            ) : (
                <></>
            )}
        </>
    )
}

export default Loaders
